import React, { createContext, useState, useEffect } from "react";

import { getNewsCount } from "../services/Services";

export const MixitContext = createContext();

const MixitContextProvider = ({ children }) => {
  const [numberOfMixitArticles, setNumberOfMixitArticles] = useState(0);
  const [mixitBuildData, setmixitBuildData] = useState([]);
  const [config, setConfig] = useState({});

  let typesListObjectArray = [
    { name: "All Articles", count: numberOfMixitArticles, id: 0 },
  ];
  let articlesCount = 0; // full total of articles

  const sitePaths = new URL(window.location.href).pathname.split("/");

  useEffect(() => {
    fetch(process.env.REACT_APP_CONFIG_PATH)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setConfig(data);
      })
      .catch((e) => {
        console.log(e.message);
      });
  }, []);

  useEffect(() => {
    if (Object.values(config).length !== 0) {
      getNewsCount(config.siteName).then((res) => {
        buildMixit(res.data[0][0]);
      });
    }
  }, [config]);

  const buildMixit = (data) => {
    data.map((category) => {
      if (category.CategoryId === null) {
        articlesCount = category.Count;
        category.CategoryId = 0;
      } else {
        // build an object for pushing into typesListObjectArray
        let typeTemp = {
          name: category.Category,
          count: category.Count,
          id: category.CategoryId,
        };

        typesListObjectArray.push(typeTemp);
      }
    });

    // sort mixit's alphabetically
    const topStore = typesListObjectArray.shift();
    typesListObjectArray.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
    typesListObjectArray.unshift(topStore);

    typesListObjectArray[0].count = articlesCount;

    let siteMatch = typesListObjectArray
      .filter((mixit) =>
        sitePaths
          .map((path) => path.toLowerCase())
          .includes(mixit.name.toLowerCase().replace(/\s+/g, "-"))
      )
      .reverse()[0];

    if (siteMatch !== undefined) {
      let obj = typesListObjectArray.find(
        (mixit) => mixit.name === siteMatch.name
      );

      if (obj !== undefined) {
        setmixitBuildData([obj]);
        setNumberOfMixitArticles(obj.count);
      } else {
        setmixitBuildData(typesListObjectArray);
        setNumberOfMixitArticles(articlesCount);
      }
    } else {
      setmixitBuildData(typesListObjectArray);
      setNumberOfMixitArticles(articlesCount);
    }
  };

  return (
    <MixitContext.Provider
      value={{
        mixitBuildData,
        numberOfMixitArticles,
        setNumberOfMixitArticles,
        config,
        sitePaths,
      }}
    >
      {children}
    </MixitContext.Provider>
  );
};

export default MixitContextProvider;
